<script lang="ts">
    import Opacity from '../../../shared/Opacity.svelte';
    import DisplayLabel from '../../Jobs/DisplayLabel.svelte';

    export let city: string;
    export let street: string;
    export let house: string;
    export let x: string | null = null;
    export let y: string | null = null;
    export let label: string | null = null;
    export let flexColumn: boolean = false;
</script>

{#if city || street}
    <div class="display-address" class:flexColumn>
        <div
            class="city bold"
            class:flexColumn
            style="flex: 0 0 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
        >
            <span>{city.trim()}</span>
        </div>
        {#if !flexColumn}<div style="color:#888; margin-right: 3px;">;</div>{/if}
        <div
            class="street light"
            class:flexColumn
            style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
        >
            <span>{street.trim()}</span>
            <span>{house.trim()}</span>
        </div>
        {#if label !== null && flexColumn}
            <div
                class="label light"
                class:flexColumn
                style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
            >
                <DisplayLabel {label} />
            </div>
        {/if}
    </div>
{:else if x !== null && y !== null}
    <div class="display-address" class:flexColumn>
        <div
            class="city bold"
            class:flexColumn
            style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
        >
            {y},
            {x}
            {#if label !== null && !flexColumn}
                , {label}
            {/if}
        </div>
        {#if label !== null && flexColumn}
            <div
                class="label light"
                class:flexColumn
                style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; "
            >
                <DisplayLabel {label} />
            </div>
        {/if}
    </div>
{:else}
    <div class="city bold">
        <Opacity>(brak adresu)</Opacity>
    </div>
{/if}

<style>
    .display-address {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        /*column-gap: 3px;*/
        width: 100%;
    }

    .display-address.flexColumn {
        flex-direction: column;
        padding: 2px 0;
    }

    .display-address .city.flexColumn {
        width: 100%;
    }

    .display-address .street.flexColumn {
        width: 100%;
    }
</style>
